import HeroSection from './HeroSection';

// ==================== ABOUT HERO ====================
export const AboutHero = () => (
  <HeroSection
    title="About "
    titleHighlight="Effective Global Staff"
    subtitle="Pioneering business management solutions for modern UK businesses"
    description="We're revolutionizing how UK businesses manage payroll, finance, and operations with secure, compliant, and genuinely easy-to-use solutions."
    ctaText="Our Vision"
    ctaLink="/vision"
    variant="about"
  />
);

// ==================== SERVICES HERO ====================
export const ServicesHero = () => (
  <HeroSection
    title="Our "
    titleHighlight="Services"
    subtitle="Comprehensive payroll, finance, and HR solutions for every business"
    description="From automated payroll processing to invoicing, accounts, VAT, and employee management, we've got everything you need in one place."
    ctaText="Explore Features"
    ctaLink="/features"
    variant="services"
  />
);

// ==================== FEATURES HERO ====================
export const FeaturesHero = () => (
  <HeroSection
    title="Our "
    titleHighlight="Platform Features"
    subtitle="Everything you need to run your business efficiently and compliantly"
    description="Discover the tools that make payroll, invoicing, accounting, and HR simple, fast, and fully compliant with UK regulations."
    ctaText="Our Services"
    ctaLink="/services"
    variant="features"
  />
);

// ==================== CONTACT HERO ====================
export const ContactHero = () => (
  <HeroSection
    title="Get In "
    titleHighlight="Touch"
    subtitle="We'd love to hear from you"
    description="Have questions? Our team is ready to help you find the perfect fit for your business, whatever part of the platform you need."
    ctaText="Book Appointment"
    ctaLink="/book"
    variant="contact"
  />
);

// ==================== BLOG HERO ====================
export const BlogHero = () => (
  <HeroSection
    title="Business "
    titleHighlight="Insights"
    subtitle="Tips, trends, and expert advice for running a UK business"
    description="Stay updated with the latest in payroll, finance, and HR compliance, plus best practices and business insights from our experts."
    ctaText="Read Latest Posts"
    ctaLink="/blog"
    variant="blog"
  />
);

// ==================== PRICING HERO ====================
export const PricingHero = () => (
  <HeroSection
    title="Simple, "
    titleHighlight="Transparent Pricing"
    subtitle="Plans for every size of business"
    description="Choose the plan that's right for you. No hidden fees, no surprises. Upgrade or downgrade anytime as your needs grow."
    ctaText="View Pricing Plans"
    ctaLink="/pricing"
    variant="pricing"
  />
);

// ==================== SUPPORT HERO ====================
export const SupportHero = () => (
  <HeroSection
    title="We're Here to "
    titleHighlight="Help"
    subtitle="24/7 support across every part of the platform"
    description="Access our comprehensive support resources, knowledge base, and dedicated support team whenever you need us."
    ctaText="Security Features"
    ctaLink="/security"
    variant="support"
  />
);

// ==================== SECURITY HERO ====================
export const SecurityHero = () => (
  <HeroSection
    title="Security "
    titleHighlight="You Can Trust"
    subtitle="Enterprise-grade protection for your business data"
    description="Bank-level encryption, regular audits, and ISO certifications ensure your payroll, financial, and employee data is always safe and secure."
    ctaText="Get Support"
    ctaLink="/support"
    variant="security"
  />
);

// ==================== CAREERS HERO ====================
export const CareersHero = () => (
  <HeroSection
    title="Join Our "
    titleHighlight="Team"
    subtitle="Help us shape the future of UK business management"
    description="We're looking for talented people who are passionate about solving real problems and making a difference."
    ctaText="Contact Us"
    ctaLink="/contact"
    variant="careers"
  />
);

// ==================== PRESS HERO ====================
export const PressHero = () => (
  <HeroSection
    title="Press & "
    titleHighlight="Media"
    subtitle="News, announcements, and press resources"
    description="Stay up to date with Effective Global Staff's latest news, product launches, and company updates."
    ctaText="View Press Releases"
    ctaLink="/press"
    variant="blog"
  />
);

// ==================== VALUES HERO ====================
export const ValuesHero = () => (
  <HeroSection
    title="Our "
    titleHighlight="Values"
    subtitle="What drives us every day"
    description="We're committed to transparency, excellence, and putting our customers first in everything we do."
    ctaText="Our Vision"
    ctaLink="/vision"
    variant="about"
  />
);

// ==================== VISION HERO ====================
export const VisionHero = () => (
  <HeroSection
    title="Our "
    titleHighlight="Vision"
    subtitle="Building the future of business management"
    description="We imagine a world where running a business is simple, compliant, and empowers teams to focus on what matters most."
    ctaText="Our Values"
    ctaLink="/values"
    variant="features"
  />
);

// ==================== PRIVACY HERO ====================
export const PrivacyHero = () => (
  <HeroSection
    title="Your Privacy "
    titleHighlight="Matters"
    subtitle="How we protect and respect your data"
    description="We take your privacy seriously and are fully committed to GDPR and data protection compliance."
    ctaText="Cookies Policy"
    ctaLink="/cookies"
    variant="security"
  />
);

// ==================== TERMS HERO ====================
export const TermsHero = () => (
  <HeroSection
    title="Terms & "
    titleHighlight="Conditions"
    subtitle="Our commitment to clarity and fairness"
    description="Everything you need to know about using Effective Global Staff, explained clearly and transparently."
    ctaText="Email Us"
    ctaLink="/contact"
    variant="blog"
  />
);

// ==================== GDPR HERO ====================
export const GdprHero = () => (
  <HeroSection
    title="GDPR "
    titleHighlight="Compliance"
    subtitle="Your data rights and our responsibilities"
    description="We fully comply with GDPR regulations and are dedicated to protecting your personal information."
    ctaText="Privacy Policy"
    ctaLink="/policy"
    variant="security"
  />
);

// ==================== COOKIES HERO ====================
export const CookiesHero = () => (
  <HeroSection
    title="Cookie "
    titleHighlight="Policy"
    subtitle="How we use cookies and tracking technologies"
    description="Transparent information about how cookies work on our site and how you can control them."
    ctaText="Call Us"
    ctaLink="/contact"
    variant="blog"
  />
);

// ==================== DEMO HERO ====================
export const DemoHero = () => (
  <HeroSection
    title="See Effective Global Staff "
    titleHighlight="in Action"
    subtitle="A personalised 30-minute walkthrough built around your business"
    description="Watch our specialists demonstrate payroll, RTI filing, invoicing, accounting, and more — live and tailored to your needs."
    ctaText="Features"
    ctaLink="/features"
    variant="features"
  />
);

// ==================== APPOINTMENT HERO ====================
export const AppointmentHero = () => (
  <HeroSection
    title="Book a Free "
    titleHighlight="Consultation"
    subtitle="Talk to a specialist — no sales pitch"
    description="Get honest, expert answers about payroll, invoicing, accounting setup, compliance, and switching providers. Completely free, no obligation."
    ctaText="Our Services"
    ctaLink="/services"
    variant="contact"
  />
);